'use client';

import { styled } from '@mui/material/styles';

export const ToolbarOffset = styled( 'div' )(({ theme }) => theme.mixins.toolbar);
